import { useQuery } from '@tanstack/react-query'

import { AppAdmin } from 'api/app-admin'

import { faqArticleKeys } from './query-keys'

export const useFaqArticleDetail = (id?: string) => {
  return useQuery({
    queryKey: faqArticleKeys.detail(id ?? ''),
    queryFn: async () => {
      const res = await AppAdmin.getFaqArticleDetail(id as string)
      return res.data?.data ?? null
    },
    enabled: !!id,
    retry: false,
  })
}
